// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Em1l","messages":"Chat_messages__3iBxO","dateDivider":"Chat_dateDivider__2AoV9"};